module.exports = __webpack_public_path__ + "static/freshman-7-5ae575560bbaf543673a1617e5c0a2a4.jpg";